import React, { Component } from 'react';
import { Button, Header, Modal, Loader, Dimmer, Icon, Grid, Transition } from 'semantic-ui-react'
import { connect } from 'react-redux';
import * as _ from 'lodash';

import { showModal, hideModal } from '../../actions'

class OnaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    const okAction = this.props.okAction || this.props.hideModal
    const cancelAction = this.props.cancelAction || this.props.hideModal

    return (
      <Transition animation="fly up" visible={this.props.isOpen} duration={this.props.duration}>
        <Modal
          size={this.props.size}
          open={this.props.isOpen}
          closeOnEscape={false}
          closeOnDimmerClick={true}
          style={{ borderRadius: "15px" }}
        >
          <Modal.Header
            as={Header}
            icon
            style={{ borderTopLeftRadius: "6px", borderTopRightRadius: "6px", color: "white", backgroundColor: this.props.isSuccess ? 'rgb(64, 195, 95)' : this.props.isError ? 'rgb(230, 99, 99)' : 'rgb(84, 157, 177)' }}
          >
            <Icon style={{ color: "white", marginTop: "16px", marginBottom: "16px" }} name={this.props.isSuccess ? 'check square outline' : 'warning circle'} />
            {this.props.title}
            <Header.Subheader style={{ color: "white" }}>
              {this.props.body}
            </Header.Subheader>
          </Modal.Header>
          {/* <Modal.Content>
          {this.props.isLoading &&
            <Dimmer active>
              <Loader />
            </Dimmer>}
          <p>{this.props.body}</p>
        </Modal.Content> */}
          <Modal.Actions
            style={{ borderBottomRightRadius: "6px", borderBottomLeftRadius: "6px" }}
          >
            <Grid columns='equal'>
              <Grid.Row textAlign='center'>
                <Grid.Column>
                  {this.props.cancelText &&
                    <Button circular loading={this.props.isLoading} content={this.props.cancelText} onClick={cancelAction} />}
                  {this.props.okText &&
                    <Button circular color={this.props.isSuccess ? 'rgb(64, 195, 95)' : 'grey'} loading={this.props.isLoading} content={this.props.okText} onClick={okAction} />}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Actions>
        </Modal>
      </Transition>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.modal.isOpen,
    size: state.modal.size,
    title: state.modal.title,
    body: state.modal.body,
    cancelText: state.modal.cancelText,
    cancelAction: state.modal.cancelAction,
    okText: state.modal.okText,
    okAction: state.modal.okAction,
    isLoading: state.modal.isLoading,
    isSuccess: state.modal.isSuccess,
    isError: state.modal.isError,
    duration: state.modal.duration
  };
};


export default connect(mapStateToProps, { showModal, hideModal })(OnaModal);